var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasolina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(8952 -252)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8952 252)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8949.473 -254.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.017,30.226a1.211,1.211,0,0,1,1.163,1.4v1.86h4.3c.7,0,1.046.233,1.046.581q0,.7-1.046.7H3.023c-.349,0-.581-.349-.465-.581,0-.233.349-.465.465-.581H7.905v-1.86c0-1.163,0-1.163,1.163-1.279h0V29.18a2.367,2.367,0,0,1-3.139-2.441V10.812A2.2,2.2,0,0,1,8.254,8.487h.814V7.324H8.835c-.814,0-.93-.116-.93-.93V3.953c0-.93.116-1.046,1.046-1.046H28.6a.549.549,0,0,1,.581.581V6.626a.737.737,0,0,1-.581.7h-.581v22.9ZM26.738,18.252H10.579V30.226H26.738Zm0-1.279v-10H10.579v10ZM9.184,3.836V5.7H27.9V3.836H9.184Zm0,27.668v1.744H27.9V31.5Zm-1.86-15.81V27.087a.764.764,0,0,0,.93.581c.465,0,.7-.349.814-.814V15.578H7.208Zm1.86-1.279v-5H8.022c-.465,0-.7.349-.7.814V14.3h1.86Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.555,15.694c-.7,0-.814-.233-.814-.814V9.068c0-.7.233-.93.93-.93H24.646c.7,0,.93.233.93.93v5.7c0,.7-.233.93-.93.93H12.555ZM24.181,9.533H13.02v4.883h11.16Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.438,28.831H11.974V19.414h5.464v1.628H14.067v2.093h3.139v1.628H14.067V27.2h3.371v1.628Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,22.9a2.259,2.259,0,0,1,1.511.349,2.745,2.745,0,0,1,1.046.93,2.908,2.908,0,0,1,.349,1.511,3.027,3.027,0,0,1-.465,1.744A3.147,3.147,0,0,1,23.367,28.6a5.632,5.632,0,0,1-2.093.349,4.392,4.392,0,0,1-1.4-.116,3.412,3.412,0,0,1-1.163-.349V26.738a12.061,12.061,0,0,0,1.163.465,6,6,0,0,0,1.279.233A3.219,3.219,0,0,0,22.2,27.32a.772.772,0,0,0,.581-.465,1.68,1.68,0,0,0,.233-.814,1.262,1.262,0,0,0-.465-1.046,2.479,2.479,0,0,0-1.4-.349h-.814a1.474,1.474,0,0,0-.7.116l-.814-.465.349-4.766H24.3v1.628H20.926v1.86h1.046Z",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolina);
export default __webpack_public_path__ + "static/media/gasolina.8582c33deb35ccb4185642310c8ba207.svg";
export { ForwardRef as ReactComponent };